import validate from 'validate.js'

const constraints = {
  educatorId: {
    presence: false
  },
  lessonId: {
    presence: false
  },
  students: {
    presence: false
  }
}

export default (data) => {
  return validate(data, constraints)
}
